import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import type { TTKey } from 'utils/types/common';
import type { TComponent } from 'utils/types/component';

import styles from './MenuItemContent.module.scss';

interface IMenuItemContentProps {
    to: string;
    label: TTKey;
    icon?: ReactElement;
    isCollapsed?: boolean;
}

const MenuItemContent: TComponent<IMenuItemContentProps> = (props) => {
    const { to, label, icon } = props;

    return (
        <Link to={to} className={styles.link}>
            {icon}
            {<span className={styles.label}>{label}</span>}
        </Link>
    );
};

export default MenuItemContent;
